import React, { useState, useEffect } from 'react';
import Modal from '../../Modal';
import styles from './new-note-field-modal.module.scss';
import { Button, ButtonStyles, ButtonSize } from '../../Button';

const EditOptionModal = ({
  value,
  onClose,
  onSave,
}: {
  value: string;
  onClose: () => void;
  onSave: (newValue: string) => void;
}) => {
  const [text, setText] = useState(value);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (text.trim()) onSave(text.trim());
  };
  return (
    <Modal onBackdropClick={onClose} className={styles.modal}>
      <div className={styles.card}>
        <h3 className={styles.title}>Edit Suggestion</h3>
        <form onSubmit={handleSubmit} className={styles.form}>
            <input
            autoFocus
            type="text"
            className={`${styles.input} mas-input`}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <div className={styles.actions}>
            <Button
              type="button"
              styleType={ButtonStyles.WHITE_GRAY}
              size={ButtonSize.SM}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              styleType={ButtonStyles.ORANGE_WHITE}
              size={ButtonSize.SM}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditOptionModal;
